module.exports = __webpack_public_path__ + "img/19.6b9a6b3b.jpg";